module.exports = __webpack_public_path__ + "static/media/153.989b92aa.jpg";